import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import config from '../../config/config'
import ManagePoiInternalLink from './ManagePoiInternalLink'
import { useAuth } from '../../contexts/AuthContext'
import { useWebsite, setFlashMessage } from '../../contexts/WebsiteContext'

const ManagePoiInternalLinksList = ({ poi, refreshList }) => {
  const { t } = useTranslation()
  const { token } = useAuth()

  const [poiInternalLinks, setPoiInternalLinks] = useState([])

  const fetchPoiInternalLinks = async () => {
    try {
      const response = await axios.get(
        `${config.apiUrl}poi-internal-link?poi=${poi.id}`,
      )
      setPoiInternalLinks(response.data)
    } catch (error) {
      console.error('An error occurred while fetching internal links:', error)

      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }

  useEffect(() => {
    const fetchPoiInternalLinks = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}poi-internal-link?poi=${poi.id}`,
        )
        setPoiInternalLinks(response.data)
      } catch (error) {
        console.error('An error occurred while fetching internal links:', error)

        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    }

    fetchPoiInternalLinks()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poi.id, refreshList])

  const handleDelete = async (internalLinkId) => {
    try {
      await axios.delete(
        `${config.apiUrl}poi-internal-link/${internalLinkId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      fetchPoiInternalLinks()
      setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success')
    } catch (error) {
      console.error('An error occurred while deleting internal link:', error)

      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }

  const handleRankingUpdate = async (direction, internalLinkId) => {
    try {
      await axios.put(
        `${config.apiUrl}poi-internal-link/${internalLinkId}`,
        { ranking: direction },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      fetchPoiInternalLinks()
      setFlashMessage(t('SUCCESS_UPDATED_MESSAGE'), 'success')
    } catch (error) {
      console.error(`Error updating link ranking (${direction}):`, error)

      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }

  return (
    <div>
      {poiInternalLinks && poiInternalLinks.length > 0 && (
        <div>
          <h2>{t('SEE_ALSO')}</h2>
          <div>
            {poiInternalLinks.map((poiInternalLink, index) => (
              <ManagePoiInternalLink
                key={index}
                poiInternalLink={poiInternalLink}
                handleDelete={handleDelete}
                handleRankingUpdate={handleRankingUpdate}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ManagePoiInternalLinksList
